import React from 'react';
import PropTypes from 'prop-types';
import { Icon, List } from '@pella/sash-framework';
import { CTA } from '../../';

import MobileMegaMenu from './mobile-mega-menu';
import MobileStandardMenu from './mobile-standard-menu';

import './index.css';

const MobileMenu = ({ data }) => {
	if (!data) return null;

	// Clicking menu items to slide in the child menu
	const onMenuItemClick = (e) => {
		document.querySelector('.mobileMenu').scrollTop = 0;
		e.currentTarget.parentNode.querySelector('.mobileChildMenu').classList.add('!right-0');
	};

	// Clicking the back button
	const onBackToMenuClick = (e) => {
		e.currentTarget.parentNode.classList.remove('!right-0');
	};

	return (
		<nav className='mobileMenu fixed right-0 top-[57px] z-[19] flex h-[calc(100%-57px)] w-full max-w-xs flex-col bg-gray-3 md:top-[68px] md:h-[calc(100%-68px)] lg:hidden'>
			<List
				bullets='none'
				className='bg-white'
			>
				{data.menu?.map((parent, index) => (
					<li
						key={index}
						className='mobileMenu-menuItem'
					>
						{parent.direct_url && (
							<CTA
								data={{
									destination: [{ destination: parent.direct_url }],
									cta_title: parent.heading,
								}}
								className='block px-4 py-3 text-lg font-semibold no-underline'
							/>
						)}

						{!parent.direct_url && (
							<button
								onClick={onMenuItemClick}
								className='flex w-full items-center justify-between px-4 py-3 text-lg'
							>
								<span className='font-semibold'>{parent.heading}</span>
								<Icon
									name='keyboard_arrow_right'
									size={24}
								/>
							</button>
						)}

						{parent.sortable?.[0] && (
							<MobileMegaMenu
								data={parent}
								onBackClick={onBackToMenuClick}
							/>
						)}

						{parent.standard?.[0] && (
							<MobileStandardMenu
								data={parent}
								onBackClick={onBackToMenuClick}
							/>
						)}
					</li>
				))}
			</List>

			{data.global?.cta?.[0] && (
				<List
					bullets='none'
					className='mobileMenu-global mt-2'
				>
					{data.global.cta
						.filter((cta) => cta.cta_title !== 'Portal Login')
						.map((globalCta, index) => (
							<li key={index}>
								<CTA
									data={globalCta}
									className='block px-4 py-2 text-sm font-semibold text-gray-65 no-underline'
								/>
							</li>
						))}
				</List>
			)}

			{data.global?.cta?.find((cta) => cta.cta_title === 'Portal Login') && (
				<div className='mobileMenu-portal mt-auto p-4'>
					<CTA
						data={{
							...data.global.cta.find((cta) => cta.cta_title === 'Portal Login'),
							button_style: 'secondary',
						}}
						className='flex items-center justify-center !bg-white py-3 text-sm [&>span]:mr-2 [&>span]:!text-base'
						wide
					/>
				</div>
			)}
		</nav>
	);
};

MobileMenu.propTypes = {
	data: PropTypes.object,
	isActive: PropTypes.bool,
};

export default MobileMenu;
